import { type CommunityMember, createCommunityMember } from 'models';
import { useQuery } from 'query';
import type { ApiClientResponseError, DefaultResponseErrorDataObject } from 'common/services';
import { getCommunityMembers } from '../../services';
import { getCommunityMembersListQueryKey } from '../keys';

// TODO: Accept `{ filter, pagination }` like the other list queries. `communityId` and `pageSize` are a flattened shortcut.
type P = {
  communityId: string;
  pageSize: number;
};

export const useCommunityMembersQuery = ({ communityId, pageSize }: P) =>
  useQuery<CommunityMember[], ApiClientResponseError<DefaultResponseErrorDataObject>>({
    async queryFn() {
      const { data: members } = await getCommunityMembers({
        config: { params: { limit: pageSize } },
        routeParams: { id: communityId },
      });

      return members.map((member) => createCommunityMember(member));
    },
    queryKey: getCommunityMembersListQueryKey({
      filter: { communityId },
      pagination: { pageSize },
    }),
    throwOnError: true,
  });
